import { get, post, put } from "../Config";

// GET Product Options
export function getProductOptions({ params }) {
  return get({ url: `/api/smom/search/ProductSamplingTypeDdl`, params });
}

// GET Channel Options  
export function getChannelOptions({ params }) {
  return get({ url: `/api/smom/search/ChannelShoppingTypeDdl`, params });
}

// POST BnaProgram Data
export function submitBnaProgram({ data }) {
  return post({ url: `/api/smom/search/survey`, data });
}
